export default "/img/SB.ac494af2f7c48bc0f59b6b97b06b91da.png";